module.exports = __webpack_public_path__ + "static/media/play-stone-boss-2.a28fbb33.png";